import { useCallback, useEffect, useRef } from 'react';

import { logInfo } from '@tools/LogsHandler.tsx';
import { fetchAddItemsFromPageAsync, fetchItemsAsync } from '@store/slices/eshopSlice.tsx';
import { useAppSelector } from '@store/store.tsx';
import type { AppDispatch } from '@store/store.tsx';

interface UseCatalogueInteractionsArgs {
  dispatch: AppDispatch;
  page: number;
  categorySelectedId: number | null;
}

interface UseCatalogueInteractionsResult {
  handleLoadMore: () => void;
}

export const useCatalogueInteractions = ({
  dispatch,
  page,
  categorySelectedId,
}: UseCatalogueInteractionsArgs): UseCatalogueInteractionsResult => {
  const hasLoaded = useAppSelector(state => state.eshop.hasLoaded);
  const isItemLoading = useAppSelector(state => state.eshop.isItemLoading);
  const hasMountedRef = useRef(false);

  useEffect(() => {
    logInfo('Componente RenderCataloguePanel montado.');
    return () => logInfo('Componente RenderCataloguePanel desmontado.');
  }, []);

  useEffect(() => {
    if (!hasLoaded && !isItemLoading) {
      dispatch(fetchItemsAsync({}));
    }
  }, [dispatch, hasLoaded, isItemLoading]);

  useEffect(() => {
    if (!hasMountedRef.current) {
      hasMountedRef.current = true;
      return;
    }

    dispatch(fetchItemsAsync({}));
  }, [dispatch, categorySelectedId]);

  const handleLoadMore = useCallback(() => {
    dispatch(fetchAddItemsFromPageAsync({ page }));
  }, [dispatch, page]);

  return {
    handleLoadMore,
  };
};

